// Fallback content for the landing page. Anything the admin saves in
// settings/general (services, faqs, titles…) always wins over these.

export const DEFAULT_SERVICES = [
  {
    titleBs: 'Profesionalna Fotografija', titleEn: 'Professional Photography',
    descriptionBs: 'Vrhunska studijska i terenska fotografija koja će vaše trenutke i proizvode prikazati u najboljem svjetlu.',
    descriptionEn: 'Top studio and field photography that will present your moments and products in the best light.',
  },
  {
    titleBs: 'Video Produkcija', titleEn: 'Video Production',
    descriptionBs: 'Cinematic video produkcija koja će vaše emocije oživjeti iznova sa svakim gledanjem.',
    descriptionEn: 'Cinematic video production that will bring your emotions to life again with every viewing.',
  },
  {
    titleBs: 'Love Story', titleEn: 'Love Story',
    descriptionBs: 'Pre-wedding sesije koje pripovijedaju vašu jedinstvenu ljubavnu priču kroz umjetnost.',
    descriptionEn: 'Pre-wedding sessions that tell your unique love story through art.',
  },
  {
    titleBs: 'PR & Marketing', titleEn: 'PR & Marketing',
    descriptionBs: 'Strategije i kampanje koje grade vaš brend i uspostavljaju jaku reputaciju.',
    descriptionEn: 'Strategies and campaigns that build your brand and establish a strong reputation.',
  },
  {
    titleBs: 'Društvene Mreže', titleEn: 'Social Media',
    descriptionBs: 'Profesionalno upravljanje društvenim mrežama za maksimalan doseg i engagement.',
    descriptionEn: 'Professional social media management for maximum reach and engagement.',
  },
  {
    titleBs: 'Grafički Dizajn', titleEn: 'Graphic Design',
    descriptionBs: 'Kreativni vizuelni identitet i dizajn koji čini vaš brend nezaboravnim.',
    descriptionEn: 'Creative visual identity and design that makes your brand unforgettable.',
  },
];

export const DEFAULT_FAQS = [
  {
    questionBs: 'Da li radite izvan BiH?', questionEn: 'Do you work outside of BiH?',
    answerBs: 'Naravno! Sa radošću putujem i radim izvan granica BiH. Putni troškovi i smještaj su na klijentu.',
    answerEn: 'Of course! I happily travel and work outside the borders of BiH.',
  },
  {
    questionBs: 'Da li objavljujete fotografije?', questionEn: 'Do you publish photos?',
    answerBs: 'Obično volim dijeliti najljepše trenutke, ali vaša privatnost mi je prioritet. Ako želite da vaše fotografije ostanu privatne, samo navedite.',
    answerEn: 'I usually like to share the most beautiful moments, but your privacy is my priority.',
  },
  {
    questionBs: 'Kada možemo očekivati fotografije?', questionEn: 'When can we expect the photos?',
    answerBs: 'Obično će vam fotografije stići u roku od 30 dana, ali uvijek šaljem mali pregled nekoliko dana nakon vjenčanja.',
    answerEn: 'Usually within 30 days, with a small preview a few days after.',
  },
];

// How a booking actually runs, in order — the numbering is real.
export const PROCESS_STEPS = [
  {
    bs: ['Upit', 'Pošaljete datum, lokaciju i šta vam treba. Javljamo se sa prvim prijedlogom.'],
    en: ['Inquiry', 'Send the date, the venue and what you need. We reply with a first proposal.'],
  },
  {
    bs: ['Interaktivna ponuda', 'Dobijete ličnu ponudu na linku: birate paket, dodatke i potvrđujete jednim klikom.'],
    en: ['Interactive offer', 'You get a personal offer link: pick the package and extras, confirm in one click.'],
  },
  {
    bs: ['Vaš dan', 'Fotograf i snimatelj prate cijeli dan, a gosti preko QR kartica šalju svoje fotografije.'],
    en: ['Your day', 'Photographer and videographer cover the whole day, guests send their photos through QR cards.'],
  },
  {
    bs: ['Galerija i film', 'Privatna galerija sa fotografijama, odvojeno ono što su uslikali gosti, i cinematic film.'],
    en: ['Gallery and film', 'A private gallery, a separate tab with the guests’ photos, and a cinematic film.'],
  },
];

export const GUEST_STEPS = [
  {
    bs: ['QR kartica na svakom stolu', 'Odštampamo elegantne kartice sa vašim imenima i QR kodom. Gost skenira kamerom — bez aplikacije, bez lozinke, bez registracije.'],
    en: ['A QR card on every table', 'Elegant cards with your names and a QR code. Guests scan with the camera — no app, no password, no sign-up.'],
  },
  {
    bs: ['Izvuku zadatak i slikaju', 'Jedan klik na kockicu i dobiju zabavan foto-zadatak. Pošalju do 5 fotografija odjednom, a telefon ih sam smanji — radi i kad je mreža krcata.'],
    en: ['They draw a task and shoot', 'One tap on the dice gives a fun photo task. Up to 5 photos at once, resized on the phone — works even on a crowded network.'],
  },
  {
    bs: ['Sve završi u vašoj galeriji', 'Fotografije ulaze u vašu privatnu galeriju — sa imenom gosta i zadatkom koji je izvukao ispisanim ispod fotografije.'],
    en: ['It all lands in your gallery', 'Photos go straight into your private gallery, with the guest’s name and task under each one.'],
  },
];

export const SYSTEMS = [
  {
    to: '/za-kolege',
    badge: ['Za kreativce', 'For creatives'],
    title: ['Vjenčani studio', 'Wedding studio'],
    accent: ['operativni sistem', 'operating system'],
    text: [
      'Kompletna agencijska platforma za fotografe i videografe — interaktivne ponude, klijent portal, kalendar, AI copywriter i Telegram notifikacije.',
      'A complete agency platform for photographers and videographers — interactive offers, client portal, calendar, AI copywriter and Telegram alerts.',
    ],
    pills: ['Ponude', 'Kalendar', 'AI', 'Telegram', 'Web'],
  },
  {
    to: '/rent-a-car',
    badge: ['Novo u ponudi', 'New'],
    title: ['Rent a car', 'Rent a car'],
    accent: ['sistem', 'system'],
    text: [
      'Web stranica + admin panel za rent-a-car kuće. Online rezervacije, praćenje kilometraže, integracija sa WhatsApp/Viber i Google Maps.',
      'Website + admin panel for rent-a-car companies. Online bookings, mileage tracking, WhatsApp/Viber and Google Maps integration.',
    ],
    pills: ['Vozila', 'Rezervacije', 'Kilometraža', 'WhatsApp', 'Maps'],
  },
];

// Web work from selimovicermin.web.app — sites, apps and systems built in-house.
export const WEB_WORKS = [
  { name: 'MojTurnir', type: 'app', url: 'https://mojturnir.online', bs: 'Organizacija liga i turnira za stoni tenis, tenis i padel. Rasporedi, rezultati i tabele na jednom mjestu.', en: 'Leagues and tournaments for table tennis, tennis and padel. Schedules, results and standings in one place.' },
  { name: 'Rent a Car sistem', type: 'system', to: '/rent-a-car', bs: 'Sistem za online rezervacije i upravljanje voznim parkom za rent-a-car firme.', en: 'Online bookings and fleet management for rent-a-car companies.' },
  { name: 'Rent a Car Aerodrom Tuzla', type: 'system', url: 'https://rentacaraerodromtuzla.ba', bs: 'Najam vozila direktno na Aerodromu Tuzla. Bez depozita, kasko uključen, rezervacija u par klikova.', en: 'Car rental right at Tuzla Airport. No deposit, full insurance, booked in a few clicks.' },
  { name: 'VizitkaBiH', type: 'app', url: 'https://vizitkabih.web.app', bs: 'Digitalne vizit karte za poslovne kontakte. Skeniraj i spremi kontakt u jedan klik.', en: 'Digital business cards. Scan and save a contact in one tap.' },
  { name: 'InzulSmart', type: 'app', url: 'https://inzulsmart.site', bs: 'Progresivna web aplikacija (PWA) iz oblasti zdravlja. Radi i bez interneta, instalira se kao aplikacija.', en: 'A health progressive web app (PWA). Works offline and installs like an app.' },
  { name: 'Weddings.ba', type: 'site', url: 'https://weddings.ba', bs: 'Elegantne, personalizovane ponude za vjenčanja. Luksuzan pristup najvažnijem danu.', en: 'Elegant, personalised wedding offers. A luxury approach to the most important day.' },
  { name: 'Mediscan', type: 'site', url: 'https://mediscan.ba', bs: 'Web stranica Poliklinike Mediscan, privatne zdravstvene ustanove.', en: 'Website for Mediscan, a private polyclinic.' },
  { name: 'Pekara Hukić', type: 'site', url: 'https://pekarahukic.ba', bs: 'Digitalni dom za porodičnu pekaru koja peče od 1890. godine.', en: 'A digital home for a family bakery baking since 1890.' },
  { name: 'Njamiii Lab', type: 'site', url: 'https://njamiiilab.ba', bs: 'Sourdough radionice, edukacija i zdrava ishrana. Prijave za radionice online.', en: 'Sourdough workshops, education and healthy food. Online workshop sign-ups.' },
  { name: 'AIDA Formula', type: 'site', url: 'https://aida.ba', bs: 'Web prezentacija brenda AIDA Formula.', en: 'Brand website for AIDA Formula.' },
  { name: 'Aktuelno.ba', type: 'portal', url: 'https://aktuelno.ba', bs: 'Informativni portal sa vijestima iz BiH i svijeta.', en: 'A news portal covering BiH and the world.' },
  { name: 'NSTK', type: 'portal', url: 'https://nstk.info', bs: 'Web stranica i informacioni sistem.', en: 'Website and information system.' },
];

export const WEB_WORK_TYPES = {
  app: ['Web aplikacija', 'Web app'],
  site: ['Web stranica', 'Website'],
  system: ['Sistem', 'System'],
  portal: ['Portal', 'Portal'],
};
